import _ from 'lodash'
import DataTable from './DataTable'
import React, { useEffect, useMemo } from 'react'
import { getTrafficReportTableColumns } from '../utils'
import TrafficColumnsPickerButton from './TrafficColumnsPickerButton'
import { tabNameToReportKey } from '../trafficReportSlice'

export default function DataTableTab({
  tabName,
  columns = [{ name: 'identifier', title: 'ID' }],
  trafficReport,
  setExportData,
  customThead,
}: any) {
  const editable = !!customThead && !!tabNameToReportKey(tabName)
  const data = trafficReport?.[tabName] || []

  const tableColumns = useMemo(() => getTrafficReportTableColumns(columns), [columns])

  const tableRows = useMemo(
    () =>
      data.map((row: any) =>
        _.chain(row)
          .pick(columns.map((col: any) => col.name))
          .toPairs()
          .map(([colName, colVal]: [string, any]) => {
            const colFormatter = columns.find((c: any) => c.name === colName)?.formatter
            return [colName, colFormatter ? colFormatter(colVal) : colVal]
          })
          .fromPairs()
          .value()
      ),
    [data, columns]
  )

  useEffect(() => {
    if (!trafficReport || !setExportData) return
    const _exportData = [
      {
        data: tableRows
          .map((row: any) =>
            _.chain(row)
              .toPairs()
              .map(([k, v]: [string, any]) => {
                const col = columns.find((c: any) => c.name === k)
                return [col?.title, v]
              })
              .fromPairs()
              .value()
          )
          .map((row: any) => {
            const strippedProductsField = _.chain(row['Products'])
              .split('\n')
              .map((p: string) => p.replace('●  ', '').replace(/"/g, '""').trim())
              .join(' | ')
              .value()
            const productsField = `"${strippedProductsField}"`
            return { ...row, Products: productsField }
          }),
        headers: tableColumns.map((col: any) => {
          const column = columns.find((c: any) => c.name === col.accessorKey)
          return column?.title
        }),
      },
    ]
    setExportData(_exportData)
  }, [tableRows, tableColumns, trafficReport])

  return (
    <div>
      {editable ? (
        <div className="tw-flex tw-justify-end tw-mb-2">
          <TrafficColumnsPickerButton tabName={tabName} />
        </div>
      ) : null}
      <DataTable
        columns={tableColumns}
        data={tableRows}
        customThead={customThead}
        showDynamicPagination={true}
        showSelectedRowsLabel={false}
      />
    </div>
  )
}
